import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { registerUser } from "../utils/register";

const RegisterPage = () => {
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    first_name: "",
    last_name: "",
    phone: "",
    profile_picture: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    const { username, email, password, first_name, last_name, phone } = formData;

    if (!username || !email || !password || !first_name || !last_name || !phone) {
      setError("All fields except profile picture are required.");
      return;
    }

    try {
      setLoading(true);
      const response = await registerUser(formData);
      setSuccess("Registration successful!");
      console.log("Response:", response.data);

      setFormData({
        username: "",
        email: "",
        password: "",
        first_name: "",
        last_name: "",
        phone: "",
        profile_picture: "",
      });
    } catch (err) {
      setError(err.response?.data?.message || "Registration failed. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0C1832] px-4 sm:px-6 md:px-10">
      <div className="bg-white bg-opacity-10 backdrop-blur-md rounded-xl shadow-2xl p-6 sm:p-8 md:p-10 w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl border border-gray-100/10 relative z-10">
        <div className="absolute -inset-1 rounded-xl bg-gradient-to-br from-[#0C1832] to-[#1F2C4C] opacity-25 blur-xl"></div>

        <form onSubmit={handleRegister} className="relative z-10 space-y-4">
          <div className="flex flex-col items-center mb-6">
            <img src="/logo-with-name.webp" alt="Logo" className="h-8 sm:h-10 mb-4" />
            <h2 className="text-2xl sm:text-3xl font-bold text-white tracking-wide">
              Register
            </h2>
          </div>

          {error && <p className="text-red-400 text-center text-sm">{error}</p>}
          {success && <p className="text-green-400 text-center text-sm">{success}</p>}

          <input
            type="text"
            name="username"
            placeholder="Username"
            value={formData.username}
            onChange={handleChange}
            className="w-full px-4 py-2 rounded bg-white/10 text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-[#0C1832] backdrop-blur border border-white/20 text-sm sm:text-base"
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            className="w-full px-4 py-2 rounded bg-white/10 text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-[#0C1832] backdrop-blur border border-white/20 text-sm sm:text-base"
            required
          />
          <input
            type="text"
            name="first_name"
            placeholder="First Name"
            value={formData.first_name}
            onChange={handleChange}
            className="w-full px-4 py-2 rounded bg-white/10 text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-[#0C1832] backdrop-blur border border-white/20 text-sm sm:text-base"
            required
          />
          <input
            type="text"
            name="last_name"
            placeholder="Last Name"
            value={formData.last_name}
            onChange={handleChange}
            className="w-full px-4 py-2 rounded bg-white/10 text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-[#0C1832] backdrop-blur border border-white/20 text-sm sm:text-base"
            required
          />
          <input
            type="text"
            name="phone"
            placeholder="Phone"
            value={formData.phone}
            onChange={handleChange}
            className="w-full px-4 py-2 rounded bg-white/10 text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-[#0C1832] backdrop-blur border border-white/20 text-sm sm:text-base"
            required
          />
          <input
            type="text"
            name="profile_picture"
            placeholder="Profile Picture URL (optional)"
            value={formData.profile_picture}
            onChange={handleChange}
            className="w-full px-4 py-2 rounded bg-white/10 text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-[#0C1832] backdrop-blur border border-white/20 text-sm sm:text-base"
          />

          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              className="w-full px-4 py-2 pr-10 rounded bg-white/10 text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-[#0C1832] backdrop-blur border border-white/20"
              required
            />
            <span
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-white cursor-pointer"
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-2 bg-gradient-to-r from-[#0C1832] to-[#1F2C4C] text-white rounded hover:brightness-110 transition-all duration-200 shadow-md disabled:opacity-50"
          >
            {loading ? "Registering..." : "Register"}
          </button>

          <p className="text-sm text-center text-white">
            Already have an account?{" "}
            <Link to="/login" className="text-blue-300 hover:underline font-medium">
              Back to Login
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default RegisterPage;
